import React, { useMemo } from 'react';
import RFQProposalResponseStore, { PageStoreContext } from 'store/pages/rfq/rfq-response/proposal-response/pageStore';
import RFQProposalResponseContent from 'components/rfq/quote/proposal-response';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import useRfqQuoteUrlParams from 'global/hooks/useRfqQuoteUrlParams';

const RFQProposalResponsePage: React.FC = () => {
  const { periodId, cartId } = useRfqQuoteUrlParams();
  const pageStore = useMemo(() => new RFQProposalResponseStore({ affiliatedId: periodId, entityId: cartId }), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <RFQProposalResponseContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default RFQProposalResponsePage;
